import DeleteTitle from "./DeleteTitle";

export default DeleteTitle;
